namespace RioERP.Reports {
    export interface OrderProductsForm {
        OrderId: Serenity.IntegerEditor;
        ProductId: Serenity.IntegerEditor;
        Quantity: Serenity.IntegerEditor;
        Cost: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmt: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        SerialKey: Serenity.StringEditor;
        HasPendrive: Serenity.BooleanEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        DownloadUrl1: Serenity.StringEditor;
        DownloadUrl2: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.IntegerEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        FranchiseeDiscountValue: Serenity.DecimalEditor;
        EFranchiseeDiscountType: Serenity.IntegerEditor;
        EOpens: Serenity.IntegerEditor;
        EWatchTime: Serenity.IntegerEditor;
        EValidity: Serenity.IntegerEditor;
        EValidityType: Serenity.IntegerEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        AllowedDevices: Serenity.StringEditor;
        IsLive: Serenity.BooleanEditor;
        EAccessStatus: Serenity.IntegerEditor;
        IsTemplateSerialKey: Serenity.BooleanEditor;
        Note: Serenity.StringEditor;
        ESerialkeyStatus: Serenity.IntegerEditor;
        TaxAmount: Serenity.DecimalEditor;
    }

    export class OrderProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderProductsForm.init)  {
                OrderProductsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DateEditor;

                Q.initFormType(OrderProductsForm, [
                    'OrderId', w0,
                    'ProductId', w0,
                    'Quantity', w0,
                    'Cost', w1,
                    'GrossAmount', w1,
                    'DiscountAmt', w1,
                    'NetAmount', w1,
                    'TaxableAmount', w1,
                    'SerialKey', w2,
                    'HasPendrive', w3,
                    'HasBooks', w3,
                    'HasCourier', w3,
                    'DownloadUrl1', w2,
                    'DownloadUrl2', w2,
                    'InvoiceCompanyId', w0,
                    'FranchiseeDiscountAmount', w1,
                    'FranchiseeDiscountValue', w1,
                    'EFranchiseeDiscountType', w0,
                    'EOpens', w0,
                    'EWatchTime', w0,
                    'EValidity', w0,
                    'EValidityType', w0,
                    'ValidTill', w4,
                    'TotalAllowedDuration', w0,
                    'AllowedDevices', w2,
                    'IsLive', w3,
                    'EAccessStatus', w0,
                    'IsTemplateSerialKey', w3,
                    'Note', w2,
                    'ESerialkeyStatus', w0,
                    'TaxAmount', w1
                ]);
            }
        }
    }
}
